import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import LoadingComponent from "../components/commons/loading/LoadingComponent";
import ResponsiveDrawer from "../components/commons/menuAppBar/Drawer";
import Header from "../components/header/Header";
import { StyledRouting } from "../components/styled/Layout";
import { isActiveToken } from "../redux/actions/auth";
import { getAppLogo } from "../redux/actions/logo";
import { changeDrawerStatus } from "../redux/actions/userPreferences";
import AuthRoutes from "./AuthRoutes";
import PublicRoutes from "./PublicRoutes";

const Routing = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const logo = useSelector((state) => state.logo.getLogo);
  const auth = useSelector((state) => state.auth);
  const drawerStatus = useSelector((state) => state.userPreferences.drawer);

  const [activeToken, setActiveToken] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(drawerStatus);
  const isAuthenticated = auth.authenticated && activeToken;
  const showDrawerAndHeader = (isAuthenticated && !(location.pathname === '/empleador'));

  axios.defaults.baseURL = CONFIG.baseURL;

  if (auth.authenticated) {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${auth.data.token}`;
  }

  useEffect(() => {
    if (!logo.data) {
      dispatch(getAppLogo());
    }
  }, [auth.authenticated, dispatch, logo.data]);

  useEffect(() => {
    if (auth.authenticated) {
      dispatch(isActiveToken()).then(() => setActiveToken(true));
    }
  }, [auth.authenticated, dispatch]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
    dispatch(changeDrawerStatus(!mobileOpen));
  };

  if (!logo.data)
    return (
      <StyledRouting.Content isAuthenticated={isAuthenticated}>
        <LoadingComponent />
      </StyledRouting.Content>
    );

  return (
    <StyledRouting.Root isAuthenticated={showDrawerAndHeader}>
      {(showDrawerAndHeader) && (
        <>
          <Header handleDrawerToggle={handleDrawerToggle} open={mobileOpen} />
          <ResponsiveDrawer
            open={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
          />
        </>
      )}
      <StyledRouting.Content isAuthenticated={showDrawerAndHeader}>
        {isAuthenticated ? <AuthRoutes authData={auth.data} /> : <PublicRoutes />}
      </StyledRouting.Content>
    </StyledRouting.Root>
  );
};

export default Routing;
